import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { rootContentStyle, stickyRootStyle } from './Header.css';

type Props = ComponentPropsWithRef<'div'> & {
  sticky?: boolean;
};

export const HeaderRoot = ({ children, sticky = true, ...delegated }: Props) => {
  return (
    <header {...delegated} className={clsx(sticky && stickyRootStyle, delegated.className)}>
      <div className={rootContentStyle}>{children}</div>
    </header>
  );
};
